import {DetailValue} from 'mc/lib';
import {formatCurrency, formatDate} from 'mc/lib/utils/commons';
import * as subjektFormatter from 'mc/lib/utils/subjektFormatter';
import * as PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {Card, CardBlock, CardHeader, Col, Row} from 'reactstrap';
import ZadostStavLabel from './ZadostStavLabel';

export default class ZadostUdajeCard extends PureComponent {

    static propTypes = {
        zadost: PropTypes.object.isRequired
    };

    render() {
        const {zadost} = this.props;
        return (
            <Card>
                <CardHeader>
                    <h2>Základní údaje</h2>
                </CardHeader>
                <CardBlock>
                    <Row>
                        <Col xs={12} sm={12} lg={4}>
                            <DetailValue label="Držitel">
                                {zadost.drzitel && subjektFormatter.getUplnyNazev(zadost.drzitel)}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={2}>
                            <DetailValue label="Číslo žádosti">
                                {zadost.cislo}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={2}>
                            <DetailValue label="Stav žádosti">
                                <ZadostStavLabel value={zadost.stav}/>
                            </DetailValue> </Col>
                        <Col xs={6} sm={4} lg={2}>
                            <DetailValue label="Datum žádosti">
                                {formatDate(zadost.datumPodani)}
                            </DetailValue>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} sm={4} lg={2}>
                            <DetailValue label="VS">
                                {zadost.vs}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={2}>
                            <DetailValue label="Částka žádosti">
                                {formatCurrency(zadost.castka)}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={2}>
                            <DetailValue label="Přeplatek">
                                {formatCurrency(zadost.preplatek)}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={2}>
                            <DetailValue label="Zvbývá zaplatit">
                                {formatCurrency(zadost.nedoplatek)}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={2}>
                            <DetailValue label="Datum uhrazení">
                                {formatDate(zadost.datumUhrazeni)}
                            </DetailValue>
                        </Col>
                    </Row>
                </CardBlock>
            </Card>
        );
    }
}
